module.exports = __webpack_public_path__ + "static/media/1_07.16d3d619.png";